import React, { Component } from "react";

export default class DomainSettings extends Component {
  render() {
    return (
      <div>
        <div className="row m-0 mt-3">
          <div className="col-md-6">
            <div class="form-group m-0 row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
              Domain name
              </label>
              <div class="form-group m-0 col-8">
                <div class="input-group mb-3 d-flex">
                  <input
                    type="text"
                    class="form-controlp-1"
                    aria-label="Amount (to the nearest dollar)"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">.lms.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary"> Save</div> or{" "}
          <a className="btn-link">Cancel</a>
        </div>
      </div>
    );
  }
}
